window.CLYDE = {
    // Global Cart configuration
    globalCart: {
      // Whether the feature is enabled
      enabled: true,
  
      // jQuery selector for the cart drawer container
      cartSelector: '#CartDrawer-CartItems',
  
      // jQuery selector for each item element contained within the cart drawer.
      // IMPORTANT: the item needs to either
      // 1) an anchor with a ?variant= query parameter in the href
      // 2) an element with a data-variant-id="" property indicating the variant ID of the item in cart
      itemSelector: '.cart-item a',
    },
  
    // interface addition to solve the underlying issues:
    onBeforeInit: function (sdk) {
      sdk.setSkuMap((variantId) => {
        switch (variantId) {
          case 6936464293930:
          case 6944255311914:
          case 40579326476330:
          case 40549365579818:
          case 7470204190762:
          case 42112258113578:
          case 7470150451242:
          case 42111930597418:
          case 7475337363498:
          case 42144075841578:
          case 42094484848682:
          case 7466738450474:
            return 40424316600362;
          default:
            return variantId;
        }
      });
    },
  
    // Callback when the Clyde SDK is ready
    onInit: function (sdk) {
      // REQUIRED: When Clyde makes changes to the cart, the merchant implementation
      // will need to refresh/re-render the cart drawer
      sdk.on('update', function() {
        // Note: The logic here is basically copied from the file cart-drawer.js function `renderContents`. That existing
        // function requires a response from a /cart/add request, which we don't have access to in this context.
        const pageCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        pageCart.querySelector('.drawer__inner').classList.contains('is-empty')
          && pageCart.querySelector('.drawer__inner').classList.remove('is-empty');
  
        const slideCartSectionElement = document.querySelector('.drawer__inner');
        const countSectionElement = document.querySelector('.shopify-section');
  
        fetch(`/cart?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const content = html.querySelector('cart-drawer');
            slideCartSectionElement.innerHTML = pageCart.getSectionInnerHTML(responseText, '.drawer__inner');
          })
      });
  
      // REQUIRED: call refresh() when the cart changes
      // (products are added/removed or the quantity changes)
      subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
        sdk.refresh();
      });
    }
  };